import { Area, AreaChart, ResponsiveContainer } from "recharts";

export interface DistributionPoint {
    value: number | string;
    count: number;
}

interface DistributionSparklineProps {
    data: DistributionPoint[];
    /** Used to make gradient ids unique when multiple sparklines share a page. */
    id: string;
    className?: string;
    color?: string;
}

function DistributionSparkline({
    data,
    id,
    className = "w-36 h-10",
    color = "hsl(var(--chart-2))",
}: DistributionSparklineProps) {
    if (!data.length) {
        return <span className="text-muted-foreground text-xs">-</span>;
    }

    const safeId = id.replace(/[^a-z0-9]/gi, "-");
    const gradientId = `dist-spark-${safeId}`;

    return (
        <div className={className}>
            <ResponsiveContainer width="100%" height="100%">
                <AreaChart data={data}>
                    <defs>
                        <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor={color} stopOpacity={0.45} />
                            <stop offset="95%" stopColor={color} stopOpacity={0.05} />
                        </linearGradient>
                    </defs>
                    <Area
                        type="monotone"
                        dataKey="count"
                        stroke={color}
                        fill={`url(#${gradientId})`}
                        strokeWidth={2}
                        isAnimationActive={false}
                    />
                </AreaChart>
            </ResponsiveContainer>
        </div>
    );
}

export default DistributionSparkline;
